<template>
    <div class="clearfix">
        <compFormEdit
            ref="editForm"
            v-model="formData"
            :formdata="getBase"
            placeholder="--"
        ></compFormEdit>
        <div class="pull-right margin-top-15 margin-bottom-15">
            <Button class="margin-right-15" type="primary" @click="nextStep"
                >下一步</Button
            >
            <Button type="default" @click="cancel">取消</Button>
        </div>
        <compModal v-model="operate.show" v-bind="operate">
            <component
                :is="operate.component"
                v-bind="operate.props"
                v-on="operate.on"
            ></component>
        </compModal>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import compTransferPlan from "../alert/transferplan";
import ajaxMixin from "../ajaxmixin";
import { HttpUpdateOutbound } from "@/service/transferplan";
import { mapState, mapGetters } from "vuex";
export default {
    components: {
        compTransferPlan,
    },
    mixins: [ajaxMixin],
    data() {
        return {
            formData: {},
            rowData: {},
            operate: {
                show: false,
            },
            loading: false,
        };
    },
    created () {
        this.getMixinWarehouse(true);
    },
    computed: {
        ...mapGetters("dictionary", ["getCusproductList"]),
        getBase() {
            return [
                {
                    label: "转运计划单号",
                    key: "transitPlanOrderNo",
                    tag: "div",
                    children: (h) => {
                        return (
                            <Input
                                value={this.rowData.transitPlanOrderNo}
                                readonly
                            >
                                <Icon
                                    style="cursor: pointer;"
                                    slot="suffix"
                                    type="md-search"
                                    nativeOnClick={this.handleChoosePlan.bind(
                                        this
                                    )}
                                ></Icon>
                            </Input>
                        );
                    },
                    style: "margin-bottom: -2px;",
                },
                {
                    label: "来源单号",
                    key: "sourceNo",
                    required: false
                },
                {
                    label: "仓库",
                    tag: "div",
                    children: (h) => {
                        let warehouseItem = this.mixinWarehouseList.filter(
                            (item) => {
                                return item.value == this.rowData.orgWarehouseId;
                            }
                        )[0];
                        return (
                            <div class="font-bold">
                                {warehouseItem ? warehouseItem.label : "--"}
                            </div>
                        );
                    },
                    query: true,
                },
                {
                    label: "项目",
                    tag: "div",
                    children: (h) => {
                        let lineItem = this.getCusproductList.filter(
                            (item) => {
                                return item.value == this.rowData.lineId;
                            }
                        )[0];
                        return (
                            <div class="font-bold">{lineItem ? lineItem.label : "--"}</div>
                        );
                    },
                    query: true,
                },
                // {
                //     label: "集装箱号",
                //     key: "cartonNo",
                //     query: true
                // },
                {
                    label: "托盘数",
                    key: "palletQty",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0
                    },
                    required: false
                },
                {
                    label: "贴标数",
                    key: "labelQty",
                    tag: "vInputNumber",
                    props: {
                        min: 0,
                        precision: 0
                    },
                    required:false,
                },
                {
                    label: "备注",
                    key: "remark",
                    tag: "vTextarea",
                    required: false
                },
            ];
        },
    },
    methods: {
        handleChoosePlan() {
            this.operate = {
                show: true,
                title: "查找转运计划",
                component: "compTransferPlan",
                width: 800,
                showFooter: false,
                props: {
                    bound: 2
                },
                on: {
                    "on-select": (row) => {
                        console.log('select', row);
                        this.rowData = row;
                        // let cartonNo = [];
                        // if (row.gpCartonNo20) {
                        //     cartonNo.push(row.gpCartonNo20);
                        // }
                        // if (row.gpCartonNo40) {
                        //     cartonNo.push(row.gpCartonNo40);
                        // }
                        // if (row.hqCartonNo40) {
                        //     cartonNo.push(row.hqCartonNo40);
                        // }
                        // if (row.hqCartonNo45) {
                        //     cartonNo.push(row.hqCartonNo45);
                        // }
                        // cartonNo = cartonNo.length ? cartonNo.join(',') : null;
                        // this.$set(this.formData, 'cartonNo', cartonNo);
                        // this.formData.cartonNo = cartonNo;
                        this.operate.show = false;
                    },
                },
            };
        },
        async nextStep() {
            if (!this.rowData.transitPlanOrderNo) return this.$VMessage.error('请填写转运计划单号');
            this.loading = true;
            await HttpUpdateOutbound({
                ...this.formData,
                transitPlanOrderId: this.rowData.id,
                orgWarehouseId: this.rowData.orgWarehouseId,
                lineId: this.rowData.lineId,
            }).then(
                (res) => {
                    this.$router.push({
                        name: "transferPlanOutboundUpdate",
                        query: {
                            id: res.data.id,
                        },
                        params: {
                            type: "edit",
                        },
                    });
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style>
</style>
